import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database"; // for Realtime DB
import { getFirestore } from "firebase/firestore"; // for Firestore

const firebaseApiKey = process.env.REACT_APP_FIREBASE_API_KEY;
const firebaseAuthDomain = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN;
const firebaseProjectId = process.env.REACT_APP_FIREBASE_PROJECT_ID;
const firebaseStorageBucket = process.env.REACT_APP_FIREBASE_STORAGE_BUCKET;
const firebaseMessagingSenderId =
  process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID;
const firebaseDatabaseUrl = process.env.REACT_APP_FIREBASE_DATABASE_URL;
const firebaseAppId = process.env.REACT_APP_FIREBASE_APP_ID;

const firebaseConfig = {
  apiKey: firebaseApiKey,
  authDomain: firebaseAuthDomain,
  databaseURL: firebaseDatabaseUrl,
  projectId: firebaseProjectId,
  storageBucket: firebaseStorageBucket,
  messagingSenderId: firebaseMessagingSenderId,
  appId: firebaseAppId,
};

const app = initializeApp(firebaseConfig);

// Export either DB or Firestore depending on what you use
export const db = getFirestore(app); // For Realtime DB
export const rtdb = getDatabase(app);
// export const firestore = getFirestore(app);  // For Firestore
